// extracted by mini-css-extract-plugin
export default {"container":"CoupleBtns_container__5fnuy","title":"CoupleBtns_title__2SrIl","btns":"CoupleBtns_btns__psdEJ","btn":"CoupleBtns_btn__LBCAd"};